import moment from 'moment'
import isPlainObject from './isPlainObject'

export default (data, options) => {
    const {
        filename,
        filePrefix = 'download_',
        type = 'text/csv;encoding:utf-8',
    } = {...options}
    const getData = () => {
        if (typeof data === 'string') {
            return data
        }

        if (isPlainObject(data)) {
            return JSON.stringify(data)
        } else if (Array.isArray(data)) {
            const keys = Object.keys(data[0] || {})
            return [
                keys.join(', '),
                ...data.map(row => {
                    return keys.map(key => row[key]).join(', ')
                })
            ].join("\n")
        }

        return `${data}`
    }

    const date = moment(Date.now()).format('YYYY-MM-DD-HH-mm-ss')
    const csvFile = new Blob(['\uFEFF' + getData()], {type})
    const downloadLink = document.createElement('a')
    downloadLink.download = filename || `${filePrefix}${date}`
    downloadLink.href = window.URL.createObjectURL(csvFile)
    downloadLink.style.display = 'none'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
}